import React from 'react';
import LeftMenu from './LeftMenu';
import Video from './Video';
import NoResults from '../../components/NoResults';

import {host, months} from '../../assets/options';

const Item = props => {
    var item = props.data;

    item.date = new Date(item.date);
    return (
        <div className="flexItemMenu aygitem" onClick={() => props.OpenVideoHandler(item.video)}>
            <div className="Shadow aygishadow"></div>
            <div className="mycontext aygi-context">
                {/* <p> Այգու կառավարում</p> */}
                <button className="center_btn tsn agnb"><i className="fa fa-play fa-2x"/></button>
            </div>
            <div className="DisCriptionBlock">
                <p className="dp" id="keker">{item.name}</p>
                {/* <p className="dp_2">
                        {item.date.getMonth() < 10 ? "0"+item.date.getMonth() : item.date.getMonth()} / {item.date.getFullYear().toString().slice(-2)}
                    </p> */}
            </div>
            <div className="img_container aygitemImg"
                 style={{backgroundImage: `url(${item.img !== '' ? `${host}/public/uploads/${item.img}` : ''})`}}>
            </div>
        </div>
    );
}

// MyBodyContainer InMenu
// flex-container
// {props.menu === true ? <LeftMenu/> :null}

class Items extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showVideo: false,
            items: [],
            showAll: false,
            videoLink: '',
            categoryName: '',
            searchQuery: '',
        }
    }

    componentDidMount() {
        this.setState({
            items: this.props.data
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            items: nextProps.data,
            categoryName: nextProps.category
        });
    }

    OpenVideoHandler(videoLink) {
        this.setState({showVideo: true, videoLink: videoLink});
        document.body.id = 'overBody';
    }

    CloseVideoHandler(event) {
        this.setState({showVideo: false});
        document.body.removeAttribute('id');
        event.target.style.display = 'none';
    }

    handleSearchChange = (e) => {
        this.setState({searchQuery: e.target.value, showAll: false});
    }

    getFilteredItems() {
        const {items, searchQuery} = this.state;
        if (!searchQuery.trim()) return items;

        return items.filter(item =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }

    loadItems() {
        let items = [];
        const filteredItems = this.getFilteredItems();

        if (filteredItems.length === 0 && this.state.searchQuery.trim()) {
            return <NoResults searchQuery={this.state.searchQuery}/>;
        }

        let mql = window.matchMedia('(max-width: 1024px)').matches;

        var itemsCount = (!this.state.showAll && mql && filteredItems.length > 3) ? 3 : filteredItems.length;

        for (var i = 0; i < itemsCount; i++) {
            items.push(<Item key={i} data={filteredItems[i]} OpenVideoHandler={this.OpenVideoHandler.bind(this)}/>);
        }

        if (!this.state.showAll && mql && filteredItems.length > 3) items.push(
            <button key="seeMore" className="seeMoreBtn" onClick={() => {
                this.setState({showAll: true})
            }}>
                Տեսնել բոլորը
            </button>);

        return items;
    }

    render() {
        var filteredItems = this.getFilteredItems();

        return (
            <React.Fragment>
                <div className="MyBodyContainer InMenu">
                    {
                        this.state.showVideo ? <Video videoLink={this.state.videoLink}
                                                      CloseVideoHandler={this.CloseVideoHandler.bind(this)}/> : null
                    }

                    <LeftMenu this={this.props.this}/>

                    <div className="list-with-filter">
                        <div className="ResultsContainer">
                            <p className="categoryTitle">{this.state.categoryName}</p>
                            <p className="SeachResults">գտնվել է {filteredItems.length} տեսանյութ</p>
                        </div>
                        <div className="searchContainer">
                            <input
                                type="text"
                                className="searchInput"
                                placeholder="Որոնել..."
                                value={this.state.searchQuery}
                                onChange={this.handleSearchChange}
                            />
                        </div>

                        <div className="flex-container flexfixer aygflex">
                            {this.loadItems()}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Items;
